import { __awaiter, __generator, __assign } from '../node_modules/tslib/tslib.es6.js';
import '../api/graphQl/brand.js';
import '../api/graphQl/product.js';
import { sendText } from '../api/utils.js';
import { buildTrackingParams } from './analytics.js';

var sendTextCallback = function (phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, trackingEventName) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, sourceMetaData, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                queryParams = buildTrackingParams({ trackingParams: trackingParams, mainEntity: mainEntity });
                sourceMetaData = {};
                if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product') {
                    sourceMetaData.sku = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.stacklineSku;
                    sourceMetaData.brandId = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity.brandId;
                }
                else if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand') {
                    sourceMetaData.brandId = parseInt("".concat(mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.id));
                }
                return [4 /*yield*/, sendText(axios, {
                        phoneNumber: phoneNumber,
                        queryParams: queryParams,
                        source: (mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product'
                            ? 'productLandingPage'
                            : (mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'brand'
                                ? 'brandLandingPage'
                                : 'outerPage',
                        sourceMetaData: sourceMetaData,
                    })];
            case 1:
                result = _a.sent();
                if (analyticsTrack) {
                    analyticsTrack(trackingEventName, __assign(__assign({}, queryParams), { phoneNumber: phoneNumber }));
                }
                return [2 /*return*/, result];
        }
    });
}); };

export { sendTextCallback };
//# sourceMappingURL=textMessage.js.map
